import { render, staticRenderFns } from "./OutboundMessageItem.vue?vue&type=template&id=51b4d374&scoped=true&"
import script from "./OutboundMessageItem.vue?vue&type=script&lang=js&"
export * from "./OutboundMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./OutboundMessageItem.vue?vue&type=style&index=0&id=51b4d374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4d374",
  null
  
)

export default component.exports